"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var NavMenu_1 = require("./NavMenu");
var Footer_1 = require("./Footer");
var styles_1 = require("@material-ui/styles");
var styles_2 = require("@material-ui/core/styles");
var theme = styles_2.createMuiTheme({
    palette: {
        primary: {
            main: "#28a745",
        },
        secondary: {
            main: "#6c757d"
        }
    }
});
exports.default = (function (props) { return (React.createElement(styles_1.ThemeProvider, { theme: theme },
    React.createElement(NavMenu_1.default, null),
    React.createElement(reactstrap_1.Container, null, props.children),
    React.createElement(Footer_1.default, null))); });
//# sourceMappingURL=Layout.js.map